<script setup>
import { h, isVNode } from 'vue';
import AiIdentity from 'dashboard/components-next/ai/AiIdentity.vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const renderIcon = () => {
  if (!props.icon) return null;
  if (props.icon === 'i-woot-captain') return h(AiIdentity);
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
